export const generalDescriptionSkeleton = [
    // Header section (optional)
    {
        span: 15,
        height: "32px",
        classes: "marginTop-56",
    },
    // Content section
    {
        span: 15,
        height: "192px", // 8 lines * 24px line-height (default lineLimit)
        classes: "marginTop-16",
    },
    // See more/less button (conditional)
    {
        span: 2,
        height: "24px",
        classes: "marginTop-4",
    },
]
